import { useState } from 'react';
import { Badge, Button, Card, Col, Empty, Row, Select, Tag, Typography } from 'antd';
import { FormOutlined, CheckCircleFilled, UserOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { loadSurveys, hasVoted, Survey } from '../api/surveys';

const { Title, Text } = Typography;

const CATEGORIES = ['All', 'Transport', 'Food & Agriculture', 'Environment', 'Community', 'Health', 'Other'];

const CAT_COLORS: Record<string, string> = {
  Transport: 'blue', 'Food & Agriculture': 'green', Environment: 'cyan',
  Community: 'purple', Health: 'red', Other: 'default',
};

export default function SurveyList() {
  const surveys = loadSurveys();
  const [cat, setCat] = useState('All');

  const filtered = cat === 'All' ? surveys : surveys.filter(s => s.category === cat);

  return (
    <div style={{ padding: 24 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <Title level={3} style={{ margin: 0 }}>Community Surveys</Title>
        <div style={{ display: 'flex', gap: 12 }}>
          <Select value={cat} onChange={setCat} style={{ width: 180 }}>
            {CATEGORIES.map(c => <Select.Option key={c} value={c}>{c}</Select.Option>)}
          </Select>
          <Link to="/create">
            <Button type="primary" icon={<FormOutlined />}>Create Survey</Button>
          </Link>
        </div>
      </div>

      {filtered.length === 0 ? (
        <Empty description="No surveys in this category yet." />
      ) : (
        <Row gutter={[16, 16]}>
          {filtered.map((s: Survey) => {
            const voted = hasVoted(s.id);
            const isOpen = !s.closedAt;
            return (
              <Col key={s.id} xs={24} sm={12} lg={8}>
                <Card
                  hoverable
                  actions={[
                    voted || !isOpen
                      ? <Link to={`/results/${s.id}`}><Button type="text" icon={<CheckCircleFilled style={{ color: '#52c41a' }} />}>View Results</Button></Link>
                      : <Link to={`/take/${s.id}`}><Button type="text" icon={<FormOutlined />}>Take Survey</Button></Link>
                  ]}
                >
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
                    <Tag color={CAT_COLORS[s.category] ?? 'default'}>{s.category}</Tag>
                    <Badge
                      status={isOpen ? 'processing' : 'default'}
                      text={<Text style={{ fontSize: 12 }}>{isOpen ? 'Open' : 'Closed'}</Text>}
                    />
                  </div>
                  <Title level={5} style={{ marginBottom: 6 }}>{s.title}</Title>
                  <Text type="secondary" style={{ fontSize: 12, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                    {s.description}
                  </Text>
                  <div style={{ marginTop: 12, display: 'flex', gap: 12, fontSize: 12, color: '#999' }}>
                    <span><UserOutlined /> {s.responseCount} responses</span>
                    <span>{s.questions.length} questions</span>
                    <span>{s.city}</span>
                  </div>
                  {voted && (
                    <div style={{ marginTop: 8 }}>
                      <Tag icon={<CheckCircleFilled />} color="success">You responded</Tag>
                    </div>
                  )}
                </Card>
              </Col>
            );
          })}
        </Row>
      )}
    </div>
  );
}
